// extracted by mini-css-extract-plugin
export default {"hotTubGridItem":"HotTubGridItem_hotTubGridItem__odfmu","title":"HotTubGridItem_title__ud5gA","brand":"HotTubGridItem_brand__DAbul"};